module.exports = __webpack_public_path__ + "img/npsVolume.f706d33d.png";